/* eslint-disable jsx-a11y/anchor-is-valid */
import { globalVariables } from "helper/globalVariables";
import Dropdown from "shared/Components/dropdown";
import Loader from "shared/Components/loader";

export const TrialDetailModal = ({
  date,
  location,
  level,
  host,
  openDate,
  closeDate,
  cutoffDate,
  title,
  renderButton,
  threeDotData,
  onSelectOption,
  deleteLoading,
}) => (
  <div class={`bg-white md:hidden w-80`}>
    <div class="flex justify-start flex-col border-b pb-3">
      <h2 class="text-lg font-semibold text-gray-900">{title}</h2>
      <h2 class="text-sm text-gray-600">{date}</h2>
    </div>
    <div className="mt-4">
      {deleteLoading ? (
        <Loader />
      ) : (
        <Dropdown
          dropdownOptions={threeDotData}
          placeholder={globalVariables.action}
          width={"w-[120px]"}
          onChange={(option) => onSelectOption(option)}
        />
      )}
    </div>
    <div class="flex justify-start flex-col mt-4">
      <h2 class="text-xs text-gray-600">{globalVariables.location}</h2>
      <h2 class="text-md">{location}</h2>
    </div>
    {/* <div class="flex justify-start flex-col mt-4">
      <h2 class="text-xs text-gray-600">{globalVariables.level}</h2>
      <h2 class="text-md">{level}</h2>
    </div> */}
    <div class="flex justify-start flex-col mt-4">
      <h2 class="text-xs text-gray-600">{globalVariables.host}</h2>
      <h2 class="text-md">{host}</h2>
    </div>

    <div class="flex justify-start flex-col mt-4">
      <h2 class="text-xs text-gray-600">{globalVariables.openDate}</h2>
      <h2 class="text-md">{openDate}</h2>
    </div>
    <div class="flex justify-start flex-col mt-4">
      <h2 class="text-xs text-gray-600">{globalVariables.closeDate}</h2>
      <h2 class="text-md">{closeDate}</h2>
    </div>
    {cutoffDate && (
      <div class="flex justify-start flex-col mt-4">
        <h2 class="text-xs text-gray-600">{globalVariables.cutoffDate}</h2>
        <h2 class="text-md">{cutoffDate}</h2>
      </div>
    )}
    <div className="mt-4">{renderButton()}</div>
  </div>
);
